import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Welcome } from './components/Welcome';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { WhyKBella } from './components/WhyKBella';
import { Testimonials } from './components/Testimonials';
import { Gallery } from './components/Gallery';
import { BookingBanner } from './components/BookingBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-body text-brand-charcoal bg-brand-white selection:bg-brand-teal selection:text-white" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Welcome data-id="element-4" />
        <Services data-id="element-5" />
        <BeforeAfter data-id="element-6" />
        <WhyKBella data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Gallery data-id="element-9" />
        <BookingBanner data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}